import * as React from "react";

/**
 * Trailing-edge debounce: returns `value` only after `delay` ms of no further
 * changes. Keeps the HQ search box from firing a request on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delay = 100): T {
  const [debounced, setDebounced] = React.useState(value);
  React.useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
